import { ref } from '@nuxtjs/composition-api';
import customFormGql from './query/customForm.gql';
import { useApi } from '~/composables/useApi';

type customFormResponse = {
  getFormResponse: [],  
};

export function useCustForm(){
  const loading = ref();
  const { query } = useApi();    
  const useCustFormData = async (queryVariables) => {
    const getFormResponse = ref<any | null>(null);
    try {
      loading.value = true;
        query<customFormResponse>(customFormGql,queryVariables)
          .then((response) => {
            loading.value = false;
            getFormResponse.value = response?.data;
          })
          .catch((errors) => {
            getFormResponse.value = errors;
          })
      return {
        getFormResponse,
      };
    } catch (err) {
      
    } finally {
      loading.value = false;
    }
  };
  return {useCustFormData, loading}
}
export default useCustForm;